'use client'
import { RecentSearchListItem } from '@/src/hooks/srp/recentSearch'
import { useLocale, useTranslations } from 'next-intl'
import { useState } from 'react'
import { FlightSearchTabs as FlightSearchTabsComponent } from './flightSearchTabs'
import { featureConfig } from '@/src/utils/featureConfig'
import { VARIANT } from '@/src/utils/buildUtils'

interface FlightSearchTabsProps {
    isMobile: boolean
    serverRecentSearches: RecentSearchListItem[]
    hideMulticity?: boolean
    fromParam?: any[] | null
    toParam?: any[] | null
}

export const FlightSearchTabs = ({
    isMobile,
    serverRecentSearches,
    hideMulticity,
    fromParam,
    toParam
}: FlightSearchTabsProps) => {
    const [tabValue, setTabValue] = useState(0)
    const locale = useLocale()
    const t = useTranslations('header')
    const { VISA } = featureConfig[VARIANT]

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        if (newValue === 1) {
            const hotelsHref = '/hotels'
            window.location.href = hotelsHref
        } else if (newValue === 2) {
            // Visa tab – no locale for Cleartrip
            const thirdHref = VISA ? '/visa' : `/${locale}/flights-hotels`
            window.location.href = thirdHref
        } else {
            // Flights tab - stay on current page
            setTabValue(newValue)
        }
    }

    return (
        <FlightSearchTabsComponent
            t={t}
            tabValue={tabValue}
            onTabChange={handleTabChange}
            isMobile={isMobile}
            serverRecentSearches={serverRecentSearches}
            hideMulticity={hideMulticity}
            fromParam={fromParam}
            toParam={toParam}
            showVisaTab={VISA}
        />
    )
}
